import React from 'react';
import facebook from '../../assets/quick-links/facebook.png';
import instagram from '../../assets/quick-links/instagram.png';
import x from '../../assets/quick-links/x.png';
import tiktok from '../../assets/quick-links/tiktok.png';
import youtube from '../../assets/quick-links/youtube.png';
import snapchat from '../../assets/quick-links/snapchat.png';
import linkedin from '../../assets/quick-links/linkedin.png';
import telegram from '../../assets/quick-links/telegram.svg';
import whatsapp from '../../assets/quick-links/whatsapp.svg';
import discord from '../../assets/quick-links/discord.svg';
import custom from '../../assets/quick-links/custom.png';
import { QuickLinkIcon } from './quick-link-types';

const FILES: Record<string, string> = {
  facebook,
  instagram,
  x,
  tiktok,
  youtube,
  snapchat,
  linkedin,
  telegram,
  whatsapp,
  discord,
  custom,
};

type PlatformGlyphProps = {
  platformId: string;
  name: string;
  icon?: QuickLinkIcon;
  size?: number;
};

export default function PlatformGlyph({
  platformId,
  name,
  icon,
  size = 32,
}: PlatformGlyphProps): JSX.Element {
  const frame = { width: size, height: size, objectFit: 'cover' as const };
  const file = FILES[platformId];
  if (file) return <img src={file} alt="" width={size} height={size} style={frame} />;
  if (icon?.kind === 'url') {
    return <img src={icon.href} alt="" width={size} height={size} style={frame} />;
  }
  const letter = (name || platformId || '?').trim().slice(0, 1).toUpperCase() || '?';
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 6,
        background: '#e8e8e8',
        fontWeight: 700,
      }}
    >
      {letter}
    </span>
  );
}

PlatformGlyph.defaultProps = {
  icon: undefined,
  size: 32,
};
